export const enMultiVendorEcommerce = {
  hero: {
    title: "Multi-vendor eCommerce CMS with Web & Mobile Apps",
    subtitle: "Complete multi-vendor eCommerce management system with mobile and web applications",
    imageAlt: "Multi-vendor marketplace dashboard showing vendor management"
  },
  features: {
    multiVendor: {
      title: "Multi-vendor Platform",
      description: "End-to-end solution supporting admin, vendors, customers, and delivery personnel with separate dashboards"
    },
    mobileApps: {
      title: "Native Mobile Applications",
      description: "High-performance iOS and Android apps built with Flutter for vendors and customers"
    },
    posSystem: {
      title: "Integrated POS System",
      description: "Omnichannel point-of-sale solution syncing online and physical store operations"
    },
    seo: {
      title: "Advanced SEO Tools",
      description: "Built-in SEO optimization with product schema markup, sitemaps, and URL customization"
    },
    loyalty: {
      title: "Loyalty & Rewards",
      description: "Customizable rewards program with points system, referral bonuses, and VIP tiers"
    },
    security: {
      title: "Enterprise Security",
      description: "PCI-DSS compliance, two-factor authentication, and regular security audits"
    }
  },
  techStack: {
    title: "Technology Stack",
    backend: {
      title: "Backend",
      laravel: "Laravel 10 framework with API-first design",
      php: "PHP 8.2+ with OPcache optimization",
      architecture: "Microservices-ready architecture"
    },
    frontend: {
      title: "Frontend",
      web: "React.js with Next.js for storefront",
      mobile: "Flutter 3 for cross-platform apps",
      state: "Redux for complex state management"
    },
    integrations: {
      title: "Integrations",
      payments: "Stripe, PayPal, Razorpay gateways",
      shipping: "FedEx, UPS, DHL integrations",
      analytics: "Google Analytics and Hotjar"
    }
  },
  dashboard: {
    title: "Powerful Management Dashboard",
    description: "Complete control over your marketplace with real-time analytics and vendor management",
    demoAlt: "Multi-vendor eCommerce admin dashboard preview",
    features: {
      "1": "Real-time sales and vendor analytics",
      "2": "Commission and payout management",
      "3": "Multi-store inventory tracking",
      "4": "Marketing and promotion tools",
      "5": "Customer support interface"
    }
  },
  cta: {
    title: "Ready to Launch Your Multi-vendor Marketplace?",
    description: "Our complete eCommerce solution will help you start and grow your online business",
    buttonText: "View Demo",
    buttonAriaLabel: "View demo of the multi-vendor eCommerce platform"
  },
  demo:{
    title: "Multi-vendor eCommerce Demo",
  }
};

export const frMultiVendorEcommerce = {
  hero: {
    title: "CMS eCommerce Multi-vendeur avec Applications Web & Mobiles",
    subtitle: "Système complet de gestion eCommerce multi-vendeur avec applications mobiles et web",
    imageAlt: "Aperçu du tableau de bord du marché multi-vendeur montrant la gestion des vendeurs"
  },
  features: {
    multiVendor: {
      title: "Plateforme Multi-vendeur",
      description: "Solution de bout en bout prenant en charge l'administrateur, les vendeurs, les clients et le personnel de livraison avec des tableaux de bord séparés"
    },
    mobileApps: {
      title: "Applications Mobiles Natives",
      description: "Applications iOS et Android haute performance développées avec Flutter pour les vendeurs et les clients"
    },
    posSystem: {
      title: "Système POS Intégré",
      description: "Solution omnicanale de point de vente synchronisant les opérations en ligne et en magasin physique"
    },
    seo: {
      title: "Outils SEO Avancés",
      description: "Optimisation SEO intégrée avec balisage de schéma de produit, sitemaps et personnalisation d'URL"
    },
    loyalty: {
      title: "Fidélité & Récompenses",
      description: "Programme de récompenses personnalisable avec système de points, bonus de parrainage et niveaux VIP"
    },
    security: {
      title: "Sécurité d'Entreprise",
      description: "Conformité PCI-DSS, authentification à deux facteurs et audits de sécurité réguliers"
    }
  },
  techStack: {
    title: "Technologie Stack",
    backend: {
      title: "Backend",
      laravel: "Framework Laravel 10 avec conception API-first",
      php: "PHP 8.2+ avec optimisation OPcache",
      architecture: "Architecture prête pour les microservices"
    },
    frontend: {
      title: "Frontend",
      web: "React.js avec Next.js pour la vitrine",
      mobile: "Flutter 3 pour des applications multiplateformes",
      state: "Redux pour la gestion d'état complexe"
    },
    integrations: {
      title: "Intégrations",
      payments: "Passerelles Stripe, PayPal, Razorpay",
      shipping: "Intégrations FedEx, UPS, DHL",
      analytics: "Google Analytics et Hotjar"
    }
  },
  dashboard: {
    title: "Tableau de Bord de Gestion Puissant",
    description: "Contrôle complet de votre marché avec des analyses en temps réel et une gestion des vendeurs",
    demoAlt: "Aperçu du tableau de bord administrateur eCommerce multi-vendeur",
    features: {
      "1": "Analytique des ventes et des vendeurs en temps réel",
      "2": "Gestion des commissions et des paiements",
      "3": "Suivi des stocks multi-boutiques",
      "4": "Outils de marketing et de promotion",
      "5": "Interface de support client"
    }
  },
  cta: {
    title: "Prêt à Lancer Votre Marché Multi-vendeur?",
    description: "Notre solution eCommerce complète vous aidera à démarrer et à développer votre entreprise en ligne",
    buttonText: "Voir la Démo ",
    buttonAriaLabel: "Voir la démo de la plateforme eCommerce multi-vendeur"
  } ,
  demo:{
    title: "Démo eCommerce Multi-vendeur",
  }
};

export const nlMultiVendorEcommerce = {
  hero: {
    title: "Multi-vendor eCommerce CMS met Web & Mobiele Apps",
    subtitle: "Compleet multi-vendor eCommerce beheersysteem met mobiele en webapplicaties",
    imageAlt: "Dashboard van multi-vendor marktplaats toont leveranciersbeheer"
  },
  features: {
    multiVendor: {
      title: "Multi-vendor Platform",
      description: "End-to-end oplossing voor beheerder, leveranciers, klanten en bezorgers met aparte dashboards"
    },
    mobileApps: {
      title: "Native Mobiele Applicaties",
      description: "Hoogwaardige iOS- en Android-apps gebouwd met Flutter voor leveranciers en klanten"
    },
    posSystem: {
      title: "Geïntegreerd POS-systeem",
      description: "Omnichannel kassasysteem dat online en fysieke winkeloperaties synchroniseert"
    },
    seo: {
      title: "Geavanceerde SEO-tools",
      description: "Ingebouwde SEO-optimalisatie met product schema markup, sitemaps en URL-aanpassing"
    },
    loyalty: {
      title: "Loyalty & Beloningen",
      description: "Aanpasbaar beloningsprogramma met puntensysteem, referral bonussen en VIP-niveaus"
    },
    security: {
      title: "Enterprise Beveiliging",
      description: "PCI-DSS compliance, tweefactorauthenticatie en regelmatige beveiligingsaudits"
    }
  },
  techStack: {
    title: "Technologiestack",
    backend: {
      title: "Backend",
      laravel: "Laravel 10 framework met API-first ontwerp",
      php: "PHP 8.2+ met OPcache optimalisatie",
      architecture: "Microservices-ready architectuur"
    },
    frontend: {
      title: "Frontend",
      web: "React.js met Next.js voor de winkel",
      mobile: "Flutter 3 voor cross-platform apps",
      state: "Redux voor complexe state management"
    },
    integrations: {
      title: "Integraties",
      payments: "Stripe, PayPal, Razorpay betaalgateways",
      shipping: "FedEx, UPS, DHL integraties",
      analytics: "Google Analytics en Hotjar"
    }
  },
  dashboard: {
    title: "Krachtig Beheerdashboard",
    description: "Volledige controle over uw marktplaats met realtime analytics en leveranciersbeheer",
    demoAlt: "Preview van multi-vendor eCommerce admin dashboard",
    features: {
      "1": "Realtime verkoop- en leveranciersanalyses",
      "2": "Commissie- en uitbetalingsbeheer",
      "3": "Multi-store voorraadtracking",
      "4": "Marketing- en promotietools",
      "5": "Klantenservice-interface"
    }
  },
  cta: {
    title: "Klaar om uw multi-vendor marktplaats te lanceren?",
    description: "Onze complete eCommerce-oplossing helpt u uw online bedrijf te starten en te laten groeien",
    buttonText: "Bekijk Demo",
    buttonAriaLabel: "Bekijk demo van het multi-vendor eCommerce platform"
  } ,
  demo:{
    title: "Multi-vendor eCommerce Demo",
  }
};

export const deMultiVendorEcommerce = {
  hero: {
    title: "Multi-Vendor eCommerce CMS mit Web- & Mobile-Apps",
    subtitle: "Komplettes Multi-Vendor eCommerce-Managementsystem mit mobilen und Web-Anwendungen",
    imageAlt: "Multi-Vendor-Marktplatz-Dashboard zeigt Anbieterverwaltung"
  },
  features: {
    multiVendor: {
      title: "Multi-Vendor Plattform",
      description: "End-to-End-Lösung für Admin, Anbieter, Kunden und Lieferpersonal mit separaten Dashboards"
    },
    mobileApps: {
      title: "Native Mobile Apps",
      description: "Leistungsstarke iOS- und Android-Apps mit Flutter für Anbieter und Kunden"
    },
    posSystem: {
      title: "Integriertes POS-System",
      description: "Omnichannel-Kassensystem, das Online- und Filialbetrieb synchronisiert"
    },
    seo: {
      title: "Erweiterte SEO-Tools",
      description: "Integrierte SEO-Optimierung mit Produkt-Schema-Markup, Sitemaps und URL-Anpassung"
    },
    loyalty: {
      title: "Treue & Prämien",
      description: "Anpassbares Prämienprogramm mit Punktesystem, Empfehlungsboni und VIP-Stufen"
    },
    security: {
      title: "Enterprise-Sicherheit",
      description: "PCI-DSS-Konformität, Zwei-Faktor-Authentifizierung und regelmäßige Sicherheitsprüfungen"
    }
  },
  techStack: {
    title: "Technologie-Stack",
    backend: {
      title: "Backend",
      laravel: "Laravel 10 Framework mit API-First-Design",
      php: "PHP 8.2+ mit OPcache-Optimierung",
      architecture: "Microservices-fähige Architektur"
    },
    frontend: {
      title: "Frontend",
      web: "React.js mit Next.js für den Storefront",
      mobile: "Flutter 3 für plattformübergreifende Apps",
      state: "Redux für komplexes State-Management"
    },
    integrations: {
      title: "Integrationen",
      payments: "Stripe, PayPal, Razorpay Zahlungs-Gateways",
      shipping: "FedEx, UPS, DHL Integrationen",
      analytics: "Google Analytics und Hotjar"
    }
  },
  dashboard: {
    title: "Leistungsstarkes Verwaltungsdashboard",
    description: "Vollständige Kontrolle über Ihren Marktplatz mit Echtzeit-Analysen und Anbieterverwaltung",
    demoAlt: "Vorschau des Multi-Vendor eCommerce Admin Dashboards",
    features: {
      "1": "Echtzeit-Verkaufs- und Anbieteranalysen",
      "2": "Provisions- und Auszahlungsmanagement",
      "3": "Multi-Store-Bestandsverfolgung",
      "4": "Marketing- und Promotion-Tools",
      "5": "Kundensupport-Interface"
    }
  },
  cta: {
    title: "Bereit, Ihren Multi-Vendor-Marktplatz zu starten?",
    description: "Unsere komplette eCommerce-Lösung hilft Ihnen, Ihr Online-Geschäft zu starten und zu wachsen",
    buttonText: "Demo ansehen",
    buttonAriaLabel: "Demo der Multi-Vendor eCommerce Plattform ansehen"
  }   ,
  demo:{
    title: "Multi-Vendor eCommerce Demo",
  }
};